<template>
  <div class="b-ticket-summary">
    <CartMovie v-if="showMovie" />  
  
    <div class="b-ticket-summary__el-holding">
      <ul class="b-ticket-summary__groups">
        <!-- Tickets -->
        <li v-if="showGroupTickets">
          <div class="b-ticket-summary__title">
            {{ dictionary.cartSummaryTicketsTitle }}
          </div>
          <div
            v-for="(item, index) in selectedTickets"
            :key="index"
            class="b-ticket-summary__sum-wrapper">
            <div class="b-ticket-summary__name">
              {{ item.count }} x {{ item.ticketDescription }}
            </div>
            <div class="b-ticket-summary__price">
              {{ roundToDigits(item.ticketPrice * item.count) }} € <br>          
            </div>
          </div>
          <!-- prepeaid voucher -->
          <template v-if="hasPrepaidVouchers">
            <li>
              <div class="b-ticket-summary__sum-wrapper">
                <div class="b-ticket-summary__name">
                  {{ store.getUserVouchersCodes.length }} x
                  {{ dictionary.prepaidVoucherCode }}
                </div>
                <div class="b-ticket-summary__price">0 €</div>
              </div>
            </li>
          </template>
          <!-- discount voucher -->
          <template v-if="hasDiscountVouchers">
            <li>
              <div class="b-ticket-summary__sum-wrapper">
                <div class="b-ticket-summary__name">
                  {{ store.getUserVouchersCodes.length }} x
                  {{ dictionary.discountVoucherCode }}
                </div>
                <div class="b-ticket-summary__price">
                  {{ roundToDigits(store.getUserVouchersTotalPrice) }} €
                </div>
              </div>
            </li>
          </template>
        </li>

        <!-- Canteen -->
        <li v-if="showGroupProducts">
          <div class="b-ticket-summary__title">
            {{ dictionary.cartSummaryProductsTitle }}
          </div>
          <div
            v-for="(item, index) in store.getAllSelectedProducts"
            :key="index"
            class="b-ticket-summary__sum-wrapper">
            <div class="b-ticket-summary__name">
              {{ item.count }} x {{ store.getAllSelectedProducts[index].name }}
            </div>
            <div class="b-ticket-summary__price">
              {{ roundToDigits(item.price * item.count) }} €
            </div>
          </div>
        </li>

        <!-- Credit Note -->
        <li v-if="store.creditVoucher">
          <div class="b-ticket-summary__sum-wrapper">
            <div class="b-ticket-summary__discount-title">
              {{ dictionary.creditVoucherTitle }}
            </div>
            <div class="b-ticket-summary__discount-value">
              -{{ roundToDigits(store.creditVoucher.discountAmount) }} €
            </div>
          </div>
        </li>
      </ul>
    </div>
    <div class="b-ticket-summary__total-wrapper">
      <div class="b-ticket-summary__total-wrapper__title">
        {{ dictionary.total }}
      </div>
      <div class="b-ticket-summary__total-wrapper__total-amount">
        {{ roundToDigits(store.getTotalCart) }} €
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, getCurrentInstance } from 'vue'
import { useBookingStore } from './../../../store/BookingStore'
import CartMovie from './CartMovie.vue'
import constants from '../../../../lib/constants'
import { roundToDigits } from '../../../../lib/lib'
const { dictionary } = getCurrentInstance().appContext.config.globalProperties
const store = useBookingStore()
const { selectedTickets } = store.bookingProgress

const props = defineProps({
  isShoppingCafe: { type: Boolean },
})

const showMovie = computed(() => {
  const { wizardStep, selectedMovie } = store.bookingProgress
  return selectedMovie && wizardStep === 4
})

const showGroupTickets = computed(() => {
  const { selectedMovie } = store.bookingProgress
  return selectedMovie
})

const showGroupProducts = computed(() => {
  if (props.isShoppingCafe) {
    return true
  }
  const products = store.getAllSelectedProducts
  return Object.keys(products).length
})

// const userAddedDealVoucher = computed(() => {
//   return store.getCD4UTickets.length && store.getCD4UTickets[0].count
// })

const hasPrepaidVouchers = computed(() => {
  return (
    store.getUserVouchersCodes.length &&
    !store.tickets.length &&
    store.getVoucherType === constants.prepaidVoucherType
  )
})
const hasDiscountVouchers = computed(() => {
  return (
    store.getUserVouchersCodes.length &&
    store.getVoucherType === constants.discountVoucherType
  )
})
</script>
